// P8 — Référentiel gazetteer des villes (cf. CityGazetteerController).
import callAPI from "../callApi";
import path from "../variables";

const Cities = {
	// Liste filtrable :
	//   country=ID, region=Centre, is_major=1, search=ya, paginate=none
	list: (filter = "") =>
		callAPI(
			"GET",
			`${path.base}/planning/cities${filter || ""}`,
			"",
			"listing gazetteer cities"
		),

	// Liste flat tous les enregistrements (utile pour les pickers).
	// Bypass cache à activer si fraîcheur critique.
	all: (countryId?: number) =>
		callAPI(
			"GET",
			`${path.base}/planning/cities?paginate=none${countryId ? `&country=${countryId}` : ""}`,
			"",
			"all gazetteer cities"
		),

	// Crée une city (root only — la Policy rejette les autres en 403).
	create: (data: any) =>
		callAPI(
			"POST",
			`${path.base}/planning/cities`,
			data,
			"create gazetteer city"
		),

	// Met à jour une city (root only).
	update: (uuid: string, data: any) =>
		callAPI(
			"PUT",
			`${path.base}/planning/cities/${uuid}`,
			data,
			"update gazetteer city"
		),

	// Suppression soft-delete (root only).
	remove: (uuid: string) =>
		callAPI(
			"DELETE",
			`${path.base}/planning/cities/${uuid}`,
			"",
			"delete gazetteer city"
		),

	// Suggère les arrêts intermédiaires entre 2 villes (heuristique
	// corridor server-side). Retourne un array ordonné de cities.
	intermediatesBetween: (fromUuid: string, toUuid: string) =>
		callAPI(
			"GET",
			`${path.base}/planning/cities/${fromUuid}/intermediates-to/${toUuid}`,
			"",
			"intermediates between cities"
		),
};

export default Cities;
